var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 604,
    viewBox: "0 0 397 604",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -38.4,
    y: -37.4469,
    width: 473.487,
    height: 679.381
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(19.2px)",
      clipPath: "url(#bgblur_0_5601_10780_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 38.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5601_10780",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.769 16.9531C244.769 8.11658 237.605 0.953125 228.769 0.953125H16C7.16344 0.953125 0 8.11659 0 16.9531V587.534C0 596.37 7.16341 603.534 16 603.534H380.687C389.524 603.534 396.687 596.37 396.687 587.534V74.6961C396.687 65.8595 389.524 58.6961 380.687 58.6961H260.769C251.932 58.6961 244.769 51.5327 244.769 42.6961V16.9531Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.769 16.9531C244.769 8.11658 237.605 0.953125 228.769 0.953125H16C7.16344 0.953125 0 8.11659 0 16.9531V587.534C0 596.37 7.16341 603.534 16 603.534H380.687C389.524 603.534 396.687 596.37 396.687 587.534V74.6961C396.687 65.8595 389.524 58.6961 380.687 58.6961H260.769C251.932 58.6961 244.769 51.5327 244.769 42.6961V16.9531Z",
    fill: "white",
    fillOpacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1.95312H228.769V-0.046875H16V1.95312ZM1 587.534V16.9531H-1V587.534H1ZM380.687 602.534H16V604.534H380.687V602.534ZM395.687 74.6961V587.534H397.687V74.6961H395.687ZM380.687 57.6961H260.769V59.6961H380.687V57.6961ZM245.769 42.6961V16.9531H243.769V42.6961H245.769ZM260.769 57.6961C252.484 57.6961 245.769 50.9804 245.769 42.6961H243.769C243.769 52.0849 251.38 59.6961 260.769 59.6961V57.6961ZM397.687 74.6961C397.687 65.3073 390.076 57.6961 380.687 57.6961V59.6961C388.971 59.6961 395.687 66.4118 395.687 74.6961H397.687ZM380.687 604.534C390.076 604.534 397.687 596.923 397.687 587.534H395.687C395.687 595.818 388.971 602.534 380.687 602.534V604.534ZM-1 587.534C-1 596.923 6.61113 604.534 16 604.534V602.534C7.7157 602.534 1 595.818 1 587.534H-1ZM228.769 1.95312C237.053 1.95312 243.769 8.66887 243.769 16.9531H245.769C245.769 7.5643 238.157 -0.046875 228.769 -0.046875V1.95312ZM16 -0.046875C6.61116 -0.046875 -1 7.56431 -1 16.9531H1C1 8.66887 7.71573 1.95312 16 1.95312V-0.046875Z",
    fill: "#D9D9D9",
    mask: "url(#path-1-inside-1_5601_10780)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5601_10780_clip_path",
    transform: "translate(38.4 37.4469)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.769 16.9531C244.769 8.11658 237.605 0.953125 228.769 0.953125H16C7.16344 0.953125 0 8.11659 0 16.9531V587.534C0 596.37 7.16341 603.534 16 603.534H380.687C389.524 603.534 396.687 596.37 396.687 587.534V74.6961C396.687 65.8595 389.524 58.6961 380.687 58.6961H260.769C251.932 58.6961 244.769 51.5327 244.769 42.6961V16.9531Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.984be121180673134664b031b8dbe3f7.svg";
export { ForwardRef as ReactComponent };